"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ArweaveUtils = require("../utils");

var WebCryptoDriver =
/*#__PURE__*/
function () {
  function WebCryptoDriver() {
    _classCallCheck(this, WebCryptoDriver);

    this.keyLength = 4096;
    this.publicExponent = 0x10001;
    this.hashAlgorithm = "sha256";

    if (!this.detectWebCrypto()) {
      throw new Error("SubtleCrypto not available!");
    }

    this.driver = window.crypto.subtle;
  }

  _createClass(WebCryptoDriver, [{
    key: "generateJWK",
    value: function () {
      var _generateJWK = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var cryptoKey, jwk;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.driver.generateKey({
                  name: "RSA-PSS",
                  modulusLength: 4096,
                  publicExponent: new Uint8Array([0x01, 0x00, 0x01]),
                  hash: {
                    name: "SHA-256"
                  }
                }, true, ["sign"]);

              case 2:
                cryptoKey = _context.sent;
                _context.next = 5;
                return this.driver.exportKey("jwk", cryptoKey.privateKey);

              case 5:
                jwk = _context.sent;
                return _context.abrupt("return", {
                  kty: jwk.kty,
                  e: jwk.e,
                  n: jwk.n,
                  d: jwk.d,
                  p: jwk.p,
                  q: jwk.q,
                  dp: jwk.dp,
                  dq: jwk.dq,
                  qi: jwk.qi
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function generateJWK() {
        return _generateJWK.apply(this, arguments);
      }

      return generateJWK;
    }()
  }, {
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(jwk, data) {
        var signature;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = this.driver;
                _context2.t1 = {
                  name: "RSA-PSS",
                  saltLength: 0
                };
                _context2.next = 4;
                return this.jwkToCryptoKey(jwk);

              case 4:
                _context2.t2 = _context2.sent;
                _context2.t3 = data;
                _context2.next = 8;
                return _context2.t0.sign.call(_context2.t0, _context2.t1, _context2.t2, _context2.t3);

              case 8:
                signature = _context2.sent;
                return _context2.abrupt("return", new Uint8Array(signature));

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function sign(_x, _x2) {
        return _sign.apply(this, arguments);
      }

      return sign;
    }()
  }, {
    key: "hash",
    value: function () {
      var _hash = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(data) {
        var digest;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.driver.digest("SHA-256", data);

              case 2:
                digest = _context3.sent;
                return _context3.abrupt("return", new Uint8Array(digest));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function hash(_x3) {
        return _hash.apply(this, arguments);
      }

      return hash;
    }()
  }, {
    key: "verify",
    value: function () {
      var _verify = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(publicModulus, data, signature) {
        var publicKey, key;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                publicKey = {
                  kty: "RSA",
                  e: "AQAB",
                  n: publicModulus
                };
                _context4.next = 3;
                return this.jwkToPublicCryptoKey(publicKey);

              case 3:
                key = _context4.sent;
                return _context4.abrupt("return", this.driver.verify({
                  name: "RSA-PSS",
                  saltLength: 0
                }, key, signature, data));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function verify(_x4, _x5, _x6) {
        return _verify.apply(this, arguments);
      }

      return verify;
    }()
  }, {
    key: "jwkToCryptoKey",
    value: function () {
      var _jwkToCryptoKey = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(jwk) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.driver.importKey("jwk", jwk, {
                  name: "RSA-PSS",
                  hash: {
                    name: "SHA-256"
                  }
                }, false, ["sign"]));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function jwkToCryptoKey(_x7) {
        return _jwkToCryptoKey.apply(this, arguments);
      }

      return jwkToCryptoKey;
    }()
  }, {
    key: "jwkToPublicCryptoKey",
    value: function () {
      var _jwkToPublicCryptoKey = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(publicJwk) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this.driver.importKey("jwk", publicJwk, {
                  name: "RSA-PSS",
                  hash: {
                    name: "SHA-256"
                  }
                }, false, ["verify"]));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function jwkToPublicCryptoKey(_x8) {
        return _jwkToPublicCryptoKey.apply(this, arguments);
      }

      return jwkToPublicCryptoKey;
    }()
  }, {
    key: "detectWebCrypto",
    value: function detectWebCrypto() {
      if (!window || !window.crypto || !window.crypto.subtle) {
        return false;
      }

      var subtle = window.crypto.subtle;

      if (typeof subtle.generateKey != "function") {
        return false;
      }

      if (typeof subtle.importKey != "function") {
        return false;
      }

      if (typeof subtle.exportKey != "function") {
        return false;
      }

      if (typeof subtle.digest != "function") {
        return false;
      }

      if (typeof subtle.sign != "function") {
        return false;
      }

      return true;
    }
  }, {
    key: "encrypt",
    value: function () {
      var _encrypt = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(data, key) {
        var initialKey, salt, derivedkey, iv, encryptedData;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.driver.importKey("raw", typeof key == "string" ? ArweaveUtils.stringToBuffer(key) : key, {
                  name: "PBKDF2",
                  length: 32
                }, false, ["deriveKey"]);

              case 2:
                initialKey = _context7.sent;
                salt = ArweaveUtils.stringToBuffer("salt");
                _context7.next = 6;
                return this.driver.deriveKey({
                  name: "PBKDF2",
                  salt: salt,
                  iterations: 100000,
                  hash: "SHA-256"
                }, initialKey, {
                  name: "AES-CBC",
                  length: 256
                }, false, ["encrypt", "decrypt"]);

              case 6:
                derivedkey = _context7.sent;
                iv = new Uint8Array(16);
                crypto.getRandomValues(iv);
                _context7.next = 11;
                return this.driver.encrypt({
                  name: "AES-CBC",
                  iv: iv
                }, derivedkey, data);

              case 11:
                encryptedData = _context7.sent;
                return _context7.abrupt("return", ArweaveUtils.concatBuffers([iv, encryptedData]));

              case 13:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function encrypt(_x9, _x10) {
        return _encrypt.apply(this, arguments);
      }

      return encrypt;
    }()
  }, {
    key: "decrypt",
    value: function () {
      var _decrypt = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(encrypted, key) {
        var initialKey, salt, derivedkey, iv, data;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.driver.importKey("raw", typeof key == "string" ? ArweaveUtils.stringToBuffer(key) : key, {
                  name: "PBKDF2",
                  length: 32
                }, false, ["deriveKey"]);

              case 2:
                initialKey = _context8.sent;
                salt = ArweaveUtils.stringToBuffer("salt");
                _context8.next = 6;
                return this.driver.deriveKey({
                  name: "PBKDF2",
                  salt: salt,
                  iterations: 100000,
                  hash: "SHA-256"
                }, initialKey, {
                  name: "AES-CBC",
                  length: 256
                }, false, ["encrypt", "decrypt"]);

              case 6:
                derivedkey = _context8.sent;
                iv = encrypted.slice(0, 16);
                _context8.next = 10;
                return this.driver.decrypt({
                  name: "AES-CBC",
                  iv: iv
                }, derivedkey, encrypted.slice(16));

              case 10:
                data = _context8.sent;
                return _context8.abrupt("return", ArweaveUtils.concatBuffers([data]));

              case 12:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function decrypt(_x11, _x12) {
        return _decrypt.apply(this, arguments);
      }

      return decrypt;
    }()
  }]);

  return WebCryptoDriver;
}();

exports.default = WebCryptoDriver;